import { useState } from "react";
import { Box } from "@mui/material";
import { usePlanContext } from "./context/planContext";
import ZipCodeDialog from "./ZipCodeDialog";
import {
    ZipBannerWrapper,
    ZipBannerContent,
    ZipBannerImageBox,
    ZipBannerImage,
    ZipBannerTextCol,
    ZipBannerTextGroup,
    ZipBannerSubText,
    ZipBannerHeadline,
    ZipBannerButton,
    ZipBannerButtonText
} from './styles/components';
export default function ZipCodeBanner() {
    const { setZipCode, zipCode } = usePlanContext();
    const [zipDialogOpen, setZipDialogOpen] = useState(false);
    const handleZipCodeClick = () => { setZipDialogOpen(true); };
    const handleZipCodeClose = () => { setZipDialogOpen(false); };
    const handleZipCodeSave = (newZipCode: string) => { setZipCode(newZipCode); setZipDialogOpen(false); };
    return (
        <>
        <ZipBannerWrapper>
            <ZipBannerContent>
                <ZipBannerImageBox>
                    <ZipBannerImage
                        src="/images/constenewImg/locationBanner.png"
                        alt="Location Banner"
                    />
                </ZipBannerImageBox>
                <ZipBannerTextCol>
                    <ZipBannerTextGroup>
                        <ZipBannerSubText>
                            We couldn’t access your location
                        </ZipBannerSubText>
                        <ZipBannerHeadline>
                            Enter your ZIP to see the best local plans.
                        </ZipBannerHeadline>
                    </ZipBannerTextGroup>
                    <ZipBannerButton variant="contained" onClick={handleZipCodeClick}>
                        <Box component="img" src="/images/constenewImg/tdesign_location-filled-white.svg" alt="Location" sx={{ width: "20px", height: "20px" }} />
                        <ZipBannerButtonText>
                            Enter your ZIP
                        </ZipBannerButtonText>
                    </ZipBannerButton>
                </ZipBannerTextCol>
            </ZipBannerContent>
        </ZipBannerWrapper>
        <ZipCodeDialog open={zipDialogOpen} zipCode={zipCode} onClose={handleZipCodeClose} onSave={handleZipCodeSave} />
        </>
    );
}